import { useNavigate } from 'react-router';
import CasRouterTabs from 'src/compass/shared/components/CasTabsView/CasRouterTabs';
import { CasErrorDisplay, CasPage } from 'src/compass/shared/components';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import { useCurrentUserEmployee } from 'src/compass/application';

import CustomersTab from './_touchpoints/components/CustomersTab';
import TouchpointsTab from './_touchpoints/components/TouchpointsTab';
import HandoffsTab from './_touchpoints/components/HandoffsTab';
import UnassignedTab from './_touchpoints/components/UnassignedTab';

const HANDOFFS_TAB_LABEL = 'Handoffs';

export const TabListEntityTouchpoints = {
  noDefault: false,
  tabs: [
    { label: 'Customers', children: <CustomersTab /> },
    { label: 'Touchpoints', children: <TouchpointsTab /> },
    { label: HANDOFFS_TAB_LABEL, children: <HandoffsTab /> },
    { label: 'Unassigned', children: <UnassignedTab /> },
  ],
};

export default function CustomersPage() {
  const navigate = useNavigate();

  const {
    data: currentUserData,
    isLoading: currentUserLoading,
    isError: isCurrentUserError,
    error: currentUserError,
  } = useCurrentUserEmployee();

  // Handoffs is main-office only; HandoffsTab also guards its own route for a typed URL.
  const {
    data: riskManagerData,
    isLoading: riskManagerLoading,
    isError: isRiskManagerError,
    error: riskManagerError,
  } = useRetrieve({ url: 'CurrentUser/RiskManager' });

  const { isFetching, isError, error } = useRetrieve({
    url: 'Utilities/EntityTouchpoint/HasUnassignedEntity',
    params: { employeeId: currentUserData?.employeeId },
    enabled: !!currentUserData?.employeeId,
    onSuccess: (response: any) => {
      if (response.hasUnassigned)
        navigate('/riskManagement/customers/Unassigned', {
          state: { autoNavigated: true },
        });
      return response;
    },
  });

  if (currentUserLoading || riskManagerLoading || isFetching) return <CasLoader />;
  if (isCurrentUserError || isRiskManagerError || isError)
    return (
      <CasErrorDisplay
        message={
          currentUserError?.message ||
          riskManagerError?.message ||
          error?.message ||
          'An error occurred'
        }
      />
    );

  const tabs = riskManagerData?.isMainOffice
    ? TabListEntityTouchpoints.tabs
    : TabListEntityTouchpoints.tabs.filter((tab) => tab.label !== HANDOFFS_TAB_LABEL);

  return (
    <CasPage title="Customers" pageTitle="Risk Management">
      <CasRouterTabs
        tabList={tabs}
        baseUrl="/riskmanagement/customers"
      />
    </CasPage>
  );
}